import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Header, CategoryRow } from "./components";
import styles from "./CategoryDrawer.module.css";
import { createNotification, CustomButton, icon } from "../../../../common/components";
import {
	environmentSwitch,
	hasCompanyPermission,
	hasPermission,
	isSegFeatureEnabled,
	Permissions,
	SegFlags,
	translate,
} from "../../../../common/providers";
import { ActionAutoService } from "../../../../api";
import { useApi, useTrackEvent } from "../../../../common/hooks";
import { setCurrentCategory, setIsAnalysisInProgress } from "../../slice/gonogo-slice";

export default function CategoryDrawer() {
	const categories = useSelector(({ gonogo }) => gonogo?.categories);
	const currentCategory = useSelector(({ gonogo }) => gonogo.currentCategory);
	const isLoadingCategories = useSelector(({ gonogo }) => gonogo.isLoadingCategories);
	const projectId = useSelector(({ context }) => context.project.id);
	const [isLaunched, setIsLaunched] = useState(false);
	const { call: launchAllActions } = useApi(ActionAutoService.triggerAll);
	const dispatch = useDispatch();
	const trackEvent = useTrackEvent();

	const isAllowedToLaunchAction = useMemo(
		() =>
			environmentSwitch({
				main:
					hasCompanyPermission([Permissions.PROJECT_LEADER, Permissions.PROJECT_MANAGER]) &&
					hasPermission([Permissions.PROJECT_LEADER]),
				veolia: true,
				smac: true,
			}),
		[]
	);
	const handleClickLaunchActions = () => {
		setIsLaunched(true);
		launchAllActions({ projectId })
			.then(() => {
				dispatch(setCurrentCategory({ ...currentCategory }));
				dispatch(setIsAnalysisInProgress(true));
				createNotification({ type: "success", message: translate("common:actions-launched") });
				trackEvent("OverviewbyCategory_autocategories_launch");
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				setIsLaunched(false);
			});
	};
	const launchButton = (
		<CustomButton
			fullWidth
			className={styles.launchBtn}
			disabled={categories.length === 0 || isLaunched}
			startIcon={icon.faWandMagic}
			variant="outlined"
			onClick={handleClickLaunchActions}
		>
			{translate("gonogo.launch-actions-button")}
		</CustomButton>
	);
	const isLaunch = !isLoadingCategories && isSegFeatureEnabled(SegFlags.AUTOMATION) && isAllowedToLaunchAction;
	return (
		<div className={styles.drawer}>
			{isLaunch && launchButton}
			<div className={styles.content} data-has-launch-btn={isLaunch}>
				<Header />
				{categories.map((cat) => (
					<CategoryRow key={cat.id} category={cat} />
				))}
			</div>
		</div>
	);
}
